import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {chain, ValidateCompanyName } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayCollectionModel, BaseAddressModel, CustomerValidationDto } from "@insite/client-framework/Types/ApiModels";

export type AddressErrors = SafeDictionary<React.ReactNode>;

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;

const isEmpty = (value: string) => value.trim().length <= 0;

export const CustomValidateCompanyName: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { companyName } = props.parameter.address;
    if (
        addressFieldDisplayCollection.companyName?.isVisible &&
        validationRules.companyName?.isRequired &&
        isEmpty(companyName)
    ) {
        props.addressErrors.companyName = siteMessage("Jobsite_validation");
    }
};

addToChainAfter(chain, ValidateCompanyName, CustomValidateCompanyName);